import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import dayjs from 'dayjs';

import '../components/winners/style.scss';

class Winner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewing_winners: false,
            selected_draw_date: null,
        };
    }

    componentDidMount() {
        this.props.actions.winnerActions.getDrawings();
    }

    render() {
        const winnersLink = (drawings, date) => {
            if (drawings.length > 0) {
                var draw = drawings.filter(ele => {
                    return ele.draw_date == date;
                });

                if (
                    draw &&
                    draw.length > 0 &&
                    draw[0].winners &&
                    draw[0].winners.length > 0
                ) {
                    return (
                        <span>
                            <a href="#" data-date={date} onClick={viewWinners}>
                                Click here to View Winner
                            </a>
                            <br />
                        </span>
                    );
                } else {
                    return <span>TBD</span>;
                }
            }
        };

        const hideWinners = () => {
            this.setState({
                viewing_winners: false,
                selected_draw_date: null,
            });
        };

        const viewWinners = e => {
            this.setState({
                viewing_winners: true,
                selected_draw_date: e.target.dataset.date,
            });
        };

        const dateDisplay = (date, drawingDate = true) => {
            const fiveYearsOut = dayjs().add(5, 'year');
            const day = dayjs(date);
            if (day.isAfter(fiveYearsOut)) {
                return 'TBD';
            } else {
                if (drawingDate) {
                    return day.format('MMMM D, YYYY');
                } else {
                    return <>11:59:59 PM {day.format('MMMM D, YYYY')}</>;
                }
            }
        };

        const renderDrawings = (drawings, date) => {
            if (date && drawings.length > 0) {
                var draws = drawings;

                var tbls = draws
                    .filter(ele => {
                        return ele.draw_date == date;
                    })
                    .map(draw => {
                        return (
                            <div
                                className=""
                                key={draw.draw_date}
                                id={draw.draw_date}
                            >
                                <div>
                                    <h1 className="text-center winners-list-heading">
                                        Draw {draw.draw_number} Winner
                                    </h1>
                                    <p className="text-center">
                                        <a href="#" onClick={hideWinners}>
                                            Return
                                        </a>{' '}
                                        to Drawing &amp; Winners Page
                                    </p>
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>City</th>
                                            <th>Prize</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {draw.winners.map(
                                            ({ name, city, prize }) => {
                                                return (
                                                    <tr key={name + city}>
                                                        <td data-title="Name">
                                                            {name}
                                                        </td>
                                                        <td data-title="City">
                                                            {city}
                                                        </td>
                                                        <td data-title="Prize">
                                                            {prize}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        );
                    });

                return (
                    <div className="promo-content">
                        <div className="">{tbls}</div>
                    </div>
                );
            }
        };

        const renderBasePage = () => {
            const { drawings = [] } = this.props.winner;

            const drawCounter = [
                '',
                'First',
                'Second',
                'Third',
                'Fourth',
                'Fifth',
            ];
            return (
                <div className="promo-content">
                    <div className="">
                        <h2 className="text-center">
                            Drawings &amp; Winners Details
                        </h2>
                        <table className="winners-table">
                            <thead>
                                <tr>
                                    <th>Drawing</th>
                                    <th>Entry Deadline</th>
                                    <th>Drawing Date</th>
                                    <th>Number of Prizes</th>
                                    <th>Winner</th>
                                </tr>
                            </thead>
                            <tbody>
                                {drawings.map(draw => {
                                    return (
                                        <tr key={draw.draw_date}>
                                            <td data-title="Drawing">
                                                {
                                                    drawCounter[
                                                        parseInt(
                                                            draw.draw_number
                                                        )
                                                    ]
                                                }{' '}
                                                <strong>
                                                    James Bond Lottery Challenge
                                                </strong>{' '}
                                                Drawing
                                            </td>
                                            <td data-title="Entry Deadline">
                                                {dateDisplay(
                                                    draw.draw_end,
                                                    false
                                                )}
                                            </td>
                                            <td data-title="Drawing Date">
                                                {dateDisplay(draw.draw_date)}
                                            </td>
                                            <td data-title="Number of Prizes">
                                                One (1) Trip Prize Package
                                            </td>
                                            <td data-title="Winner">
                                                {winnersLink(
                                                    this.props.winner.drawings,
                                                    draw.draw_date
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        };

        const winnerSwitch = () => {
            if (this.state.viewing_winners) {
                return renderDrawings(
                    this.props.winner.drawings,
                    this.state.selected_draw_date
                );
            } else {
                return renderBasePage();
            }
        };

        return (
            <Layout
                user={this.props.user}
                notification={this.props.notification}
                actions={this.props.actions}
            >
                <SEO title="Drawings and Winners" />
                <div className="winners">
                    <div className="upper-content">
                        <h1 className="text-center">Drawings &amp; Winners</h1>
                    </div>
                    <div className="lower-content">
                        <div className="inner-area">{winnerSwitch()}</div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Winner);
